import React from 'react';
import PropTypes from 'prop-types';

import PhotoOrInitials from 'components/photo_or_initials';

export default function TagTooltip({ tag }) {
  const parts = [
    tag.name,
    tag.businessLabel,
    tag.email,
    tag.phoneNumber,
  ].filter(part => part);

  if (parts.length === 0) {
    return null;
  }

  return (
    <div
      aria-label="tag-tooltip"
      className="deal-tagged-body-tag-tooltip d-flex align-items-center"
    >
      <PhotoOrInitials user={tag} />
      <div className="ms-3">
        {parts.map((part, i) => (
          <div className="text-nowrap" key={i}>{part}</div>
        ))}
      </div>
    </div>
  );
}

TagTooltip.propTypes = {
  tag: PropTypes.shape({
    businessLabel: PropTypes.string,
    email: PropTypes.string,
    name: PropTypes.string,
    phoneNumber: PropTypes.string,
  }).isRequired,
};
